import { render, staticRenderFns } from "./CreditHours.vue?vue&type=template&id=6b8c1020&"
import script from "./CreditHours.vue?vue&type=script&lang=js&"
export * from "./CreditHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports